import { useAppTheme } from './use-app-theme'
import { useMediaQuery } from './use-media-query'

export const useIsMobile = () => {
  const theme = useAppTheme()
  return useMediaQuery(`screen and (max-width: ${theme.breakpoints.values.sm - 1}px)`)
}
